export default "__VITE_ASSET__CsiFHuHm__"